import React from "react";
import * as Yup from "yup";
import Select from "react-select";
import { FiArrowLeft } from "react-icons/fi";
import { Formik, Form, Field } from "formik";
import { Content, Container } from "./styles";
import { create_user } from "../../services/user";
import { RegisterTypes } from "./types";

const Register = ({
  show,
  afterSubmit,
}: RegisterTypes) => {
  const roleOptions = [
    {
      label: "Administrador",
      id: 0,
    },
    {
      label: "Analista",
      id: 1,
    },
    {
      label: "Digitador",
      id: 2,
    },
  ];

  const schema = Yup.object().shape({
    name: Yup.string()
      .min(3, "No mínimo 3 caracteres!")
      .required("O nome do usuário é obrigatório!")
      .matches(/^[aA-zZ\s]+$/, "O nome só pode conter letras!"),

    email: Yup.string()
      .required("O e-mail do usuário é obrigatório!")
      .email("Digite um e-mail válido!"),
    role: Yup.number().required("Selecione o cargo do usuário!"),
    password: Yup.string()
      .required("É necessário criar uma senha para o usuário!")
      .min(6, "A senha deve conter ao menos 6 caracteres!")
      .max(30, "A senha não pode conter mais de 30 caracteres!"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "As senhas não conferem!")
      .required("Digite novamente a senha do usuário! "),
  });

  const customStyles = {
    option: (provided: any, state: any) => ({
      ...provided,
      fontWeight: state.isSelected ? "600" : "normal",
      color: "black",
      fontSize: state.selectProps.myFontSize,
      margin: 0,
      backgroundColor: "white",
    }),
    control: (provided: any, state: any) => ({
      ...provided,

      borderRadius: "0 0.5rem 0.5rem 0",
      height: "100%",
      width: "100%",

      ":hover": {
        border: "1px solid #2d7bbc",
      },

      ":focus": {
        border: "2px solid #2d7bbc",
      },
    }),
    container: (provided: any) => ({
      ...provided,

      height: "100%",
      width: "100%",
    }),
    menu: (provided: any) => ({
      ...provided,
      margin: 4,
    }),
    menuList: (provided: any) => ({
      ...provided,
      padding: 0,
    }),
    singleValue: (provided: any, state: any) => ({
      ...provided,
      fontSize: state.selectProps.myFontSize,
      fontWeight: "600",
    }),
  };

  const initialValues = {
    name: "",
    email: "",
    role: 0,
    password: "",
    confirmPassword: "",
  };

  const handleSubmit = async (values: any, { resetForm }: any) => {
    create_user(values);

    resetForm({});
    afterSubmit();
  };

  return (
    <Container>
      <Content>
        <div className="header">
          <FiArrowLeft id="back" onClick={() => show("hidden")} />
          <p className="register-header">Cadastrar usuário</p>
        </div>
        <Formik
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={schema}
          validateOnBlur={true}
        >
          {(props) => {
            const { values, handleBlur, setFieldValue, errors, touched } =
              props;

            return (
              <Form>
                <div className="input-wrapper">
                  <div className="wrapper">
                    {errors.name ? (
                      <Field
                        name="name"
                        placeholder={errors.name}
                        className={
                          touched.name && errors.name ? "input-error" : null
                        }
                      />
                    ) : (
                      <Field
                        name="name"
                        placeholder="Digite o nome do usuário"
                        className={
                          touched.name && errors.name ? "input-error" : null
                        }
                      />
                    )}
                  </div>
                  <div className="wrapper">
                    {errors.email ? (
                      <Field
                        name="email"
                        placeholder={
                          touched.email && errors.email
                            ? errors.email
                            : "Digite o e-mail do usuário"
                        }
                        className={
                          touched.email && errors.email ? "input-error" : null
                        }
                      />
                    ) : (
                      <Field
                        name="email"
                        placeholder="Digite o e-mail do usuário"
                        className={
                          touched.email && errors.email ? "input-error" : null
                        }
                      />
                    )}
                  </div>
                </div>

                <div className="select-wrapper">
                  <div className="select-content">
                    <p>Cargo</p>
                    <Select
                      placeholder={"Selecione o cargo"}
                      styles={customStyles}
                      options={roleOptions}
                      value={{
                        label:
                          values.role === 0
                            ? "Administrador"
                            : values.role === 1
                            ? "Analista"
                            : "Digitador",
                        id: values.role,
                      }}
                      name="role"
                      id="role"
                      onBlur={handleBlur}
                      onChange={(option) => setFieldValue("role", option!.id)}
                    />
                  </div>
                </div>
                {errors.role ? (
                  <div className="error-wrapper">
                    <p
                      style={{
                        color: "red",
                        fontWeight: 400,
                      }}
                    >
                      {errors.role}
                    </p>
                  </div>
                ) : null}

                <div className="input-wrapper">
                  <div className="wrapper">
                    {errors.password ? (
                      <Field
                        type="password"
                        name="password"
                        placeholder={
                          touched.password && errors.password
                            ? errors.password
                            : "Digite a senha do usuário"
                        }
                        className={
                          touched.password && errors.password
                            ? "input-error"
                            : null
                        }
                      />
                    ) : (
                      <Field
                        name="password"
                        type="password"
                        placeholder="Digite a senha do usuário"
                        className={
                          touched.password && errors.password
                            ? "input-error"
                            : null
                        }
                      />
                    )}
                  </div>
                  <div className="wrapper">
                    {errors.confirmPassword ? (
                      <Field
                        type="password"
                        name="confirmPassword"
                        placeholder={
                          touched.confirmPassword && errors.confirmPassword
                            ? errors.confirmPassword
                            : "Redigite a senha do usuário"
                        }
                        className={
                          touched.confirmPassword && errors.confirmPassword
                            ? "input-error"
                            : null
                        }
                      />
                    ) : (
                      <Field
                        name="confirmPassword"
                        type="password"
                        placeholder="Redigite a senha do usuário"
                        className={
                          touched.confirmPassword && errors.confirmPassword
                            ? "input-error"
                            : null
                        }
                      />
                    )}
                  </div>
                </div>
                <div className="btn-container">
                  <button className="btn-style" id="cancel-button">
                    Cancelar
                  </button>

                  <input
                    type="submit"
                    className="btn-style"
                    id="submit-button"
                    value="Enviar"
                  />
                </div>
              </Form>
            );
          }}
        </Formik>
      </Content>
    </Container>
  );
};

export default Register;
